import { SET_TYPING_VALUE } from "../constants/action-types";
import { SEND_MESSAGE } from "../constants/action-types";

export default function typing(state = "", action) {
  switch (action.type) {
    case SET_TYPING_VALUE:
      return action.payload;
    case SEND_MESSAGE:
      return "";
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/typing.js